import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutTableRapidAlerts extends Layout {
    sourceRapidAlert: DataSource;
    tableRapidAlerts: Table;
}
